import { yup } from '@guiker/yup-util'

export const stockOrderRiskAcknowledgementQuerySchema = yup.object({
  quantity: yup.number().required(),
})
